// tslint:disable:object-literal-key-quotes
import { VCLIconAliasMap } from '../icon/index';

export const ALIAS_MAP: VCLIconAliasMap = {
  'close': 'fas fa-times',
  'busy': 'fas fa-circle-notch fa-spin',
  'box': 'fas fa-square',
  'box-checked': 'fas fa-check-square',
  'circle': 'fas fa-circle',
  'circle-checked': 'fas fa-dot-circle',
  'question': 'fas fa-question-circle',
  'info': 'fas fa-info-circle',
  'success': 'fas fa-check-circle',
  'warning': 'fas fa-exclamation-triangle',
  'error': 'fas fa-exclamation-circle',
  'arrow-left': 'fas fa-angle-left',
  'arrow-right': 'fas fa-angle-right',
  'arrow-down': 'fas fa-angle-down',
  'arrow-up': 'fas fa-angle-up',
  'arrow-double-left': 'fas fa-angle-double-left',
  'arrow-double-right': 'fas fa-angle-double-right',
  'arrow-double-down': 'fas fa-angle-double-down',
  'arrow-double-up': 'fas fa-angle-double-up',
  'upload': 'fas fa-upload',
  'eye': 'fas fa-eye',
  'eye-off': 'fas fa-eye-slash',
  'star': 'fas fa-star',
  'star-half': 'fas fa-star-half-alt',
  'star-empty': 'far fa-star',
  'add': 'fas fa-plus',
  'remove': 'fas fa-minus',
  'calendar': 'fas fa-calendar',
  'clock': 'fas fa-clock',
  'menu': 'fas fa-bars'
};
